<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Swal from "sweetalert2";
import Select2 from 'vue3-select2-component';

import NoVoucher from "../receipt/cqnovoucher";
import CqWithVoucher from "../receipt/cqWithVoucher";


export default {
  page: {
    title: "Conditional Quotation",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Conditional Quotation",
      items: [
   
        {
          text: "Conditional Quotation",
          active: true,
        },
      ],
    UserlList:[{'id':'0','text': "Please Select Brand" }],
      Order_id:this.$route.params.OrderId,

      SeenButton:true,

      quotationDetail:[],

        loadingQuotation:false,

        role:localStorage.getItem('role'),

        notAuth:false,
        noAUthMsj:'',

        imAdmin:0,
        listUserCountrydata:[],
        country_id:0,
        userSelection:'0',
        CustomerId:'',
        MyCusId:'',
    };
    
  },
  mounted() {
    this.getQuotation();
  },

    methods: {
        getQuotation(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'quotation/'+this.$route.params.OrderId)
            .then(response => {
                if (response) {

                    if(response.data.status == 'fail'){
                        this.notAuth=true;
                        this.noAUthMsj = response.data.message;
                    }else{

                    
                        this.quotationDetail = response.data;
                        // console.log(response.data);
                        this.CustomerId = this.quotationDetail.user.id;
                        this.loadingQuotation=true;

                        if (typeof response.data.compasia_detail.id !== 'undefined') {
                            this.country_id = response.data.compasia_detail.id;
                            this.getMyProfile();
                        }
                    }
                } else {
                    this.messageBag = ['No record.'];
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },

        rejectButton(orderId_) {
            Swal.fire({
                title: "Are you sure you want to reject this order?",
                // text: "You won't be able to revert!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                confirmButtonText: "Yes, Reject Order!",
            }).then((result) => {
                if (result.value) {
                    const posting_ = { status: "9" };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'order/status/'+orderId_, posting_)
                    .then(response => {
                        if (response) {
                            Swal.fire("Rejected!", "Your Order has been Rejected.", "success");
                            this.SeenButton = false;
                            this.getList();
                        }else{
                            Swal.fire("Fail!", "Your Order Fail To Rejected. Please try again", "fail");
                        }
                    });
                }
            });
        },

        ApproveButton(orderId_) {
            Swal.fire({
                title: "Are you sure you want to Approve this order?",
                // text: "You won't be able to revert!",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, Approve Order!",
            }).then((result) => {
                if (result.value) {

                    const posting_ = { status: "1" };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'order/status/'+orderId_, posting_)
                    .then(response => {
                        if (response) {
                            // console.log(response.data);
                            Swal.fire("Order Confirmed!", "Our customer service will contact you soon.", "success");
                            this.SeenButton = false;
                            this.getList();
                        }else{
                            alert(response);
                            Swal.fire("Fail!", "Your Order Fail To Rejected. Please try again", "fail");
                        }
                    });
                    
                }
            });
        },

        getMyProfile(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'user/my')
            .then(response => {
                if (response) {
                    if(response.data.role_id == 1){
                        this.imAdmin = '1';
                        this.listUserCountry(this.country_id);
                        this.MyCusId = response.data.id; 
                    }
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
                console.log(this.messageBag);
            });

        },


        listUserCountry(countryId){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'user/list/'+countryId)
            .then(listUserCountry => {
                if (listUserCountry) {
                    // this.listUserCountrydata = listUserCountry.data;
                    this.UserlList  = [{'id':'0','text': "Please select User" }].concat(listUserCountry.data);
                    // console.log(this.UserlList);
                }
            })
        },

        assignOrderTo(){
            // alert(this.userSelection);
            // alert(this.quotationDetail.id);
            if(this.userSelection == '0'){
                Swal.fire("Fail!", "Please Select User", "fail");
            }else{
                const posting_ = { user_id: this.userSelection };
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'order/assign/'+this.quotationDetail.id, posting_)
                .then(response => {
                    if (response) {
                        Swal.fire("Success","Your Order has been assigned to customer", "success");
                        this.SeenButton = false;
                        this.getList();
                    }else{
                        Swal.fire("Fail!", "Your order failed to be assigned", "fail");
                    }
                });
            }
        },
        

        backhistory(){
            history.go(-1);
        },

        testPdf(){
            const quality = 1 // Higher the better but larger file
            html2canvas(document.querySelector('#demo'),
                { scale: quality }
            ).then(canvas => {
                // "pt" | "px" | "in" | "mm" | "cm" | "ex" | "em" | "pc",
                const pdf = new jsPDF('p', 'cm', 'a4');
                pdf.addImage(canvas.toDataURL('image/jpeg',10), 'jpeg', 0, 0, 21, 29.7);
                pdf.save(this.quotationDetail.QCId);
            });
        }
    },

  components: {
    Layout,
    PageHeader,
    Select2,
    NoVoucher,
    CqWithVoucher,
    
  },
}
</script>
<style >
p { margin:0 }
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="row justify-content-center" v-if="loadingQuotation">
            
            <div class="col-xxl-9">
                <button class="btn btn-info waves-effect" @click="backhistory()" type="button"> Back </button> &nbsp;&nbsp;
                <a class="btn btn-success waves-effect" :href="quotationDetail.URL">Download</a>
                <!-- <button class="btn btn-success waves-effect" type="button" id="inputGroupFileAddon04" @click="testPdf">Download</button> &nbsp;&nbsp;&nbsp;&nbsp; -->
                <span v-if="SeenButton">
                    <span v-if="role == '3' && quotationDetail.StatusId == '3' ">
                        <button class="btn btn-danger waves-effect" @click="rejectButton(quotationDetail.id)" type="button"> Reject </button> &nbsp;&nbsp;
                        <button class="btn btn-secondary bg-gradient waves-effect waves-light" @click="ApproveButton(quotationDetail.id)" type="button"> Accept </button>
                    </span>
                </span>
                <br><br>
                <div class="row" v-if="quotationDetail.StatusId == '1' && (MyCusId == CustomerId)">
                    <div class="col-lg-4">
                        <Select2 v-model="userSelection" :options="UserlList"></Select2>
                    </div>
                    <div class="col-lg-8"> </div>
                    <div class="col-lg-4">
                        <br>
                        <button class="btn btn-outline-secondary btn-md" type="button" @click="assignOrderTo">
                            <div class="btn-content">Assign</div>
                        </button>
                    </div>
                </div>

                <!-- <div class="hstack gap-2 justify-content-end d-print-none mt-4">
                    <a href="javascript:window.print()" class="btn btn-success"><i
                            class="ri-printer-line align-bottom me-1"></i> Print</a>
                    <a href="javascript:void(0);" class="btn btn-primary"><i
                            class="ri-download-2-line align-bottom me-1"></i>
                        Download</a>

                    <a href="javascript:void(0);" class="btn btn-primary">
                        <i class="ri-download-2-line align-bottom me-1"></i>
                    Email</a>
                </div> -->
                        <br><br>
                <div class="card" id="demo" ref="testHtml">
                    <div class="p-4">
                        <div class="d-sm-flex">
                            <div class="flex-grow-1">
                                <img src="@/assets/images/compasiaLogo.png" class="card-logo card-logo-dark" alt="logo dark" height="52">
                                <img src="@/assets/images/compasiaLogo.png" class="card-logo card-logo-light" alt="logo light" height="52"> <br>
                                <!-- <h3>Conditional Quotations</h3> -->
                                <br>
                                <!-- <h5><span class="fw-normal"><b>CompAsia Sdn Bhd</b></span><br></h5> sg -->
                                <h5><span class="fw-normal"><b>{{ quotationDetail.compasia_detail.company_name }}</b></span><br></h5>
                                <h6>

                                    <!-- <p class="text-muted fw-normal" id="legal-register-no">
                                        (Co Reg No: 1006653-T) 
                                    </p>
                                    <p class="text-muted fw-normal" id="legal-register-no">
                                        No. 4A, Jalan 19/1, <br>
                                        46300, Petaling Jaya, Selangor, <br>
                                        Selangor, Malaysia.
                                        <br>
                                        Tel: +603 7931 3417  <br> Fax: +603 6205 3181
                                    </p> -->

                                    <p class="text-muted fw-normal" id="legal-register-no" v-html="quotationDetail.compasia_detail.address"></p>

                                </h6>
                                
                            </div>
                            <div class="flex-shrink-0 mt-sm-0 mt-3" style="max-width: 50%;">
                                <h1><span class="fw-normal"><b>Conditional Quotation</b></span></h1>
                                <div class="row">
                                    <div class="col-xl-4">
                                    </div>
                                    <div class="col-xl-8">
                                        <br><br>
                                        <p >
                                            <b>Quotation No</b> {{ quotationDetail.QCId}}<br>
                                            <b>Order No</b> {{ quotationDetail.orderId}}<br>
                                            <b>Date</b> {{ quotationDetail.generate_quotaion }}<br>

                                        </p>
                                        <p >

                                            {{ quotationDetail.user.company_name }}<br>
                                            PIC:{{ quotationDetail.user.pic_name }}<br>
                                            {{ quotationDetail.user.company_address }}
                                            <!-- <p v-html="quotationDetail.user.company_address"></p> -->
                                          
                                            <br>
                                            Tel: {{ quotationDetail.user.pic_phone_number}} <br>
                                        </p>
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!--end card-body-->
                    <div class="card-body p-4">
                        <div class="table-responsive">
                            <span v-if="quotationDetail.device['0'].trade_in">
                                
                                <CqWithVoucher :quotationDetail="quotationDetail"></CqWithVoucher>
                            </span>
                            <span v-else>
                                <NoVoucher :quotationDetail="quotationDetail"></NoVoucher>
                            </span>
                            <!--end table-->
                        </div>
                        <div class="mt-3">
                            <span v-if='quotationDetail.remark !=""'>
                                <h6 class="text-bold text-uppercase fw-semibold mb-3">Remarks</h6>
                                <p>
                                {{ quotationDetail.remark }}
                                </p>
                            </span>
                            <h6 class="text-bold text-uppercase fw-semibold mb-3">TERMS AND CONDITIONS:</h6>
                            <div v-html='quotationDetail.tnc.cq_tnc'></div>
                        </div>
            
                         <div clas="row">  
                            <div class="col d-flex align-items-center justify-content-end" v-if='quotationDetail.currency == "MYR"'>
                                <p class="lead"> <b>
                                    A Proud Member of
                                    </b>
                                </p>
                                <img src="@/assets/images/New-High-Res-Logo.png" width="150" height="150">
                            </div>
                        </div>

                    </div>
                    <!--end card-body-->
                </div>
                <!--end card-->
            </div>
            <!--end col-->
        </div>  
        <div v-else>
            <div v-if='notAuth'>
                <div class="alert alert-warning alert-border-left alert-dismissible fade show" role="alert">
                    <i class="ri-alert-line me-3 align-middle fs-16"></i><strong>{{ noAUthMsj }}</strong>
                    
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            </div>
            <div class="spinner-border text-success" role="status" v-else>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </Layout>
</template>